module.exports = __webpack_public_path__ + "static/indianapolis-ecf49242d14b47c84f1b6340756d1835.png";